export default __webpack_public_path__ + "static/media/jigzag_thumb.f7338aeb.png";